import axios from 'axios';

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? ''
    : window.__VIDEO_BACKEND_API_URL__;
const ROOT_URL = BASE_URL + '/api';

export function request(params, token) {
  const url = ROOT_URL + params.url;
  let headers = {};
  if (token) {
    headers = {
      ...(params.headers || {}),
      Authorization: `Bearer ${token}`,
    };
  }

  return axios({
    ...params,
    url,
    headers,
  }).catch((e) => {
    throw e;
  });
}

export function post(url, data, token = '', { ...params } = {}) {
  return request(
    {
      url,
      data,
      method: 'POST',
      ...params,
    },
    token
  );
}
